import { DisplayComponent, Variant } from "./enums";
import type { ThemeConfig, VariantRenderConfiguration } from "./types";
import {
  AcquisitionNewsletterPopupTheme,
  acquisitionNewsletterPopupThemeConfig,
  ArticleDarkTheme,
  ArticleTheme,
  FooterTheme,
  LiveArticleTheme,
  NewsletterArticleBottomTheme,
  newsletterArticleBottomThemeConfig,
  NewsletterArticleTheme,
  newsletterArticleThemeConfig,
  NewsletterListTheme,
  newsletterListThemeConfig,
  useAcquisitionNewsletterPopupRender,
  useArticleRender,
} from "./variants";
import { Article20Theme, useArticle20Render } from "./variants/article-20-theme";
import { HomepageTheme, homepageThemeConfig } from "./variants/homepage-theme";
import { useHomepageRender } from "./variants/homepage-theme/hooks";
import { HomepageV2Theme, homepageV2ThemeConfig } from "./variants/homepage-v2-theme";
import { useHomepageV2Render } from "./variants/homepage-v2-theme/hooks";
export const SignedUpNewsletterSwrFetchKey = "signedUpNewsletters";

// V1 keys
export const SignedUpNewsletterV1LocalStorageKey = "subscribed_newsletters";

export const ResetAfterSuccessTimeout = 10_000;

export const DefaultThemeConfig: ThemeConfig = {
  defaultDisplayComponent: DisplayComponent.FindOutMore,
  hasResetAfterSuccess: true,
  hasSanitizeSubscribedNewsletter: true,
};

export const VariantRenderMapping: Record<Variant, VariantRenderConfiguration> = {
  [Variant.AcquisitionNewsletterPopup]: {
    config: acquisitionNewsletterPopupThemeConfig,
    hook: useAcquisitionNewsletterPopupRender,
    renderComponent: AcquisitionNewsletterPopupTheme,
  },
  [Variant.Article]: {
    hook: useArticleRender,
    renderComponent: ArticleTheme,
  },
  [Variant.Article20]: {
    hook: useArticle20Render,
    renderComponent: Article20Theme,
  },
  [Variant.ArticleDark]: {
    hook: useArticleRender,
    renderComponent: ArticleDarkTheme,
  },
  [Variant.Footer]: {
    renderComponent: FooterTheme,
  },
  [Variant.Homepage]: {
    config: homepageThemeConfig,
    hook: useHomepageRender,
    renderComponent: HomepageTheme,
  },
  [Variant.HomepageV2]: {
    config: homepageV2ThemeConfig,
    hook: useHomepageV2Render,
    renderComponent: HomepageV2Theme,
  },
  [Variant.LiveArticle]: {
    renderComponent: LiveArticleTheme,
  },
  [Variant.NewsletterArticle]: {
    config: newsletterArticleThemeConfig,
    renderComponent: NewsletterArticleTheme,
  },
  [Variant.NewsletterArticleBottom]: {
    config: newsletterArticleBottomThemeConfig,
    renderComponent: NewsletterArticleBottomTheme,
  },
  [Variant.NewsletterList]: {
    config: newsletterListThemeConfig,
    renderComponent: NewsletterListTheme,
  },
  [Variant.NewsletterPreview]: {
    config: newsletterListThemeConfig,
    renderComponent: NewsletterListTheme,
  },
  [Variant.Section]: {
    config: homepageThemeConfig,
    hook: useHomepageRender,
    renderComponent: HomepageTheme,
  },
};
